import { FPADataQuery_search_Search_advert_Advert_imageList_ImageList_images_ImageUrl } from "../../connected-components/hoc/query/__generated__/fpa-page-data.query";
import { LeasingPDPImagesQuery_vehicle_Vehicle_images_ImageUrl } from "../../connected-components/hoc/query/__generated__/pdp-images.fed.query";

export interface LeasingPDPImagesProps
  extends LeasingPDPImagesQuery_vehicle_Vehicle_images_ImageUrl {
  autotraderAllocated?: boolean;
}

export interface GalleryProps {
  advertImages: readonly FPADataQuery_search_Search_advert_Advert_imageList_ImageList_images_ImageUrl[];
  spinUrl?: string;
  videoUrl?: string;
  isLeasingPDPPage?: boolean;
}

export enum GalleryThumbnailsLength {
  SMALL = 3,
  MEDIUM = 4,
}
